import { Card, CardContent, CardHeader, Grid, Typography } from '@material-ui/core';
import { useGenericStyles } from 'common/genericStyles';
import { RepresentanteLegal } from 'common/genericTypes';
import { MdSpace } from 'm2m.components';
import React from 'react';
import { addCpfCnpjMask } from 'utils/mask';

interface InvestidorRepresentantesLegaisProps {
  representantesLegais: Array<RepresentanteLegal>;
}

export const InvestidorRepresentantesLegais: React.FC<InvestidorRepresentantesLegaisProps> = (props) => {
  const classes = useGenericStyles();
  return (
    <>
      <MdSpace />
      <Grid container spacing={3}>
        {props.representantesLegais?.map((representante, i) => (
          <Grid item key={representante.cpf} lg={4}>
            <Card variant="outlined">
              <CardHeader
                style={{ paddingBottom: 0 }}
                title={
                  <Typography className={classes.wrapTxt} variant={'h3'}>
                    {representante.nome}
                  </Typography>
                }
              />
              <CardContent>
                <div>
                  <Typography variant={'body2'}>{'CPF:'}</Typography>
                  <Typography variant={'body1'}>{addCpfCnpjMask(representante.cpf)}</Typography>
                </div>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <MdSpace />
    </>
  );
};
